export default "__VITE_ASSET__D4YGwZ2S__"